/* eslint-disable */
/* global google */
function initMap() {
  if (typeof google === 'undefined') {
    return;
  }

  const maps = document.querySelectorAll('.map');
  const geocoder = new google.maps.Geocoder();

  maps.forEach((mapEl) => {
    const address = mapEl.dataset.place;
    const styleUrl = mapEl.dataset.mapStyle;

    const loadStyle = styleUrl
      ? fetch(styleUrl)
          .then((res) => {
            if (!res.ok) throw new Error(`HTTP error ${res.status}`);
            return res.json();
          })
          .catch((err) => {
            console.error(`Не вдалося завантажити стиль з ${styleUrl}:`, err);
            return [];
          })
      : Promise.resolve([]);

    loadStyle.then((mapStyle) => {
      geocoder.geocode({ address }, (results, status) => {
        if (status === 'OK') {
          const location = results[0].geometry.location;

          const map = new google.maps.Map(mapEl, {
            center: location,
            zoom: 14,
            styles: mapStyle,
            disableDefaultUI: true,
            zoomControl: false,
            fullscreenControl: false,
            streetViewControl: false,
            mapTypeControl: false,
          });

          const customIcon = {
            url: 'images/pin.svg',
            scaledSize: new google.maps.Size(64, 64),
            origin: new google.maps.Point(0, 0),
            anchor: new google.maps.Point(20, 40),
          };

          new google.maps.Marker({
            position: location,
            map: map,
            icon: customIcon,
            title: address,
          });
        } else {
          console.error('Geocode was not successful for the following reason: ' + status);
        }
      });
    });
  });
}

window.initMap = initMap;

export default initMap;
